module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_7016.497b3996.png";